import { Typography } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { CountdownCircleTimer, TimeProps } from "react-countdown-circle-timer";

export const weddingDay = new Date("2026-11-13").getTime();

type CountdownCircleProps = {
  time: number;
  duration: number;
  remainingTimeMultiplier?: number;
  renderFunction: (props: TimeProps) => React.ReactNode;
};

const CountdownCircle = ({
  time,
  duration,
  renderFunction,
  remainingTimeMultiplier = 1,
}: CountdownCircleProps) => {
  const initialRemainingTime = time * remainingTimeMultiplier;
  const screenWidth = window.innerWidth;
  const isSmallScreen = screenWidth < 625;
  return (
    <CountdownCircleTimer
    size={isSmallScreen ? 80 : 180}
    strokeWidth={isSmallScreen ? 5 : 8}
      isPlaying
      duration={duration}
      colors={["#006B3E", "#F7B801", "#A30000", "#A30000"]}
      colorsTime={[10, 6, 3, 0]}
      onComplete={() => ({ shouldRepeat: true, delay: 1 })}
      initialRemainingTime={initialRemainingTime}
    >
      {renderFunction}
    </CountdownCircleTimer>
  );
};
const Countdown = () => {
  const screenWidth = window.innerWidth;
  const isSmallScreen = screenWidth < 625;
  const [currentTime, setCurrentTime] = useState(Date.now());

  const timeBetween = weddingDay - currentTime;
  const seconds = Math.floor((timeBetween / 1000) % 60);
  const minutes = Math.floor((timeBetween / 1000 / 60) % 60);
  const hours = Math.floor((timeBetween / (1000 * 60 * 60)) % 24);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const renderTime = (renderTimeString: string) => {
    return (
        <Typography fontFamily={"Delius Swash Caps"} >
          {renderTimeString}
        </Typography>
    );
  };
  
  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", gap: "16px", width: '60%'}}>
        <CountdownCircle
          duration={86400}
          renderFunction={() => renderTime(`${hours} ${isSmallScreen ? 'h': 'hours'}`)}
          time={hours}
          remainingTimeMultiplier={3600}
        />
        <CountdownCircle
          duration={3600}
          renderFunction={() => renderTime(`${minutes} ${isSmallScreen ? 'm': 'minutes'}`)}
          time={minutes}
          remainingTimeMultiplier={60}
        />
        <CountdownCircle
          duration={60}
          renderFunction={() => renderTime(`${seconds} ${isSmallScreen ? 's': 'seconds'}`)}
          time={seconds}
        />
      </div>
    </>
  );
};

export default Countdown;
